import { ApiError, notifyPaymentRequired } from "@/lib/api-client";

/**
 * Why the billing dialog opened. `plan_limit` / `insufficient_credits` mirror the API's 402 codes;
 * `upgrade` / `credits` are user-initiated (an Upgrade or Buy credits button).
 */
export type BillingDialogReason = "plan_limit" | "insufficient_credits" | "upgrade" | "credits";

/**
 * Opens the global upgrade / buy-credits dialog. Any 402 from `apiFetch` or a rejected sync
 * mutation already does this automatically; call it directly for buttons or custom gates.
 */
export function openBillingDialog(reason: BillingDialogReason, message = "") {
	notifyPaymentRequired(new ApiError(402, message, reason));
}

export const isPaymentRequired = (error: unknown): error is ApiError =>
	error instanceof ApiError && error.status === 402;
